export default __webpack_public_path__ + "static/media/listing-collect.700bf323.webp";